// Module
var code = "<div style=\"position:fixed;top:0;bottom:0;left:0;right:0;background-color:#fafafa;z-index:99999;text-align:center;display:flex;flex-direction:column;justify-content:center\"> <h1 style=\"font-size:200px;color:#0091ea\">404</h1> <span style=\"font-size:18px\">Запрашиваемая страница не найдена</span> </div>";
// Exports
module.exports = code;